// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"70564eea716883e32954","293":"36b45e13a8cd317f5b90","518":"13cf73c991af3379d3bc","779":"90408fcb3b429dc629f8"}[chunkId] + ".js";
};